import { useEffect, useState } from "react";
import { useParams, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { PracticeReport } from "@/components/PracticeReport";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Preview/development-only: renders a frozen Practice Report by id (F3 rendered review).
// Optional ?session=<session_id> enables the session-bound actions (email / claim / feedback).
// Never mounted in production builds (see App.js NODE_ENV gate).
export default function DevReportEntry() {
  const { reportId } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session") || undefined;
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    fetch(`${API}/simulation/report/${encodeURIComponent(reportId)}`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject())).then(setSummary).catch(() => setMissing(true));
  }, [reportId]);
  if (process.env.NODE_ENV !== "development") return <Navigate to="/" replace />;
  if (missing) return <p className="p-8 text-white" data-testid="dev-report-missing">Report not found.</p>;
  if (!summary) return <div className="min-h-[100dvh] bg-[#0a0a0a]" data-testid="dev-report-loading" />;
  return <PracticeReport summary={summary} simTitle={summary.title} simId={summary.simulation_id} sessionId={sessionId} onHome={() => navigate("/")} />;
}
